import { createFileRoute } from '@tanstack/react-router'
import { ExamsPage } from '_/features/exams/ui/pages/exams-page'

export const Route = createFileRoute('/_authenticated/exams/')({
	staticData: { title: 'examsim_title' },
	component: ExamsPage,
})
